export * from './delete-dialog.component';
export * from './delete-dialog.module';